var map = {
	"./banana": 3547,
	"./banana.svg": 3547,
	"./bg_friends": 9224,
	"./bg_friends.png": 9224,
	"./bg_friends_blendmode": 1657,
	"./bg_friends_blendmode.png": 1657,
	"./fa_yuiry": 3214,
	"./fa_yuiry.gif": 3214,
	"./feature/friends": 2667,
	"./feature/friends.png": 2667,
	"./feature/project": 543,
	"./feature/project.png": 543,
	"./feature/request": 5064,
	"./feature/request.png": 5064,
	"./feature/secure": 3049,
	"./feature/secure.png": 3049,
	"./footer__logo": 7218,
	"./footer__logo.svg": 7218,
	"./grass": 2854,
	"./grass.svg": 2854,
	"./ico_bosyu": 5560,
	"./ico_bosyu.svg": 5560,
	"./ico_cheetah": 3504,
	"./ico_cheetah.svg": 3504,
	"./ico_daily_report": 5882,
	"./ico_daily_report.svg": 5882,
	"./ico_gazelle": 8342,
	"./ico_gazelle.svg": 8342,
	"./ico_giraffa": 1190,
	"./ico_giraffa.svg": 1190,
	"./ico_globe": 6481,
	"./ico_globe.svg": 6481,
	"./ico_hippo": 6526,
	"./ico_hippo.svg": 6526,
	"./ico_meat": 1723,
	"./ico_meat.svg": 1723,
	"./lp__logo": 9919,
	"./lp__logo.svg": 9919,
	"./mail_logo": 9074,
	"./mail_logo.png": 9074,
	"./meat": 6241,
	"./meat.svg": 6241,
	"./navigation__logo": 5834,
	"./navigation__logo.svg": 5834,
	"./published_report_animation": 5012,
	"./published_report_animation.gif": 5012,
	"./savanna_balloon": 1308,
	"./savanna_balloon.svg": 1308,
	"./savanna_balloon_string": 740,
	"./savanna_balloon_string.svg": 740,
	"./savanna_face": 9292,
	"./savanna_face.svg": 9292,
	"./savanna_face_old": 8358,
	"./savanna_face_old.svg": 8358,
	"./savanna_flower": 6882,
	"./savanna_flower.svg": 6882,
	"./savanna_friends": 5686,
	"./savanna_friends.svg": 5686,
	"./savanna_lion_gray_busy": 4703,
	"./savanna_lion_gray_busy.svg": 4703,
	"./savanna_lion_gray_busy_alpha": 8194,
	"./savanna_lion_gray_busy_alpha.svg": 8194,
	"./savanna_lion_gray_normal": 6673,
	"./savanna_lion_gray_normal.svg": 6673,
	"./savanna_lion_gray_normal_alpha": 2459,
	"./savanna_lion_gray_normal_alpha.svg": 2459,
	"./savanna_logomark": 8897,
	"./savanna_logomark.svg": 8897,
	"./savanna_work": 2176,
	"./savanna_work.svg": 2176,
	"./savao_ancestor": 3922,
	"./savao_ancestor.svg": 3922,
	"./savao_ascension": 5354,
	"./savao_ascension.svg": 5354,
	"./savao_expressionless": 4708,
	"./savao_expressionless.svg": 4708,
	"./savao_pien": 7357,
	"./savao_pien.svg": 7357,
	"./savao_slightly_smile": 5844,
	"./savao_slightly_smile.svg": 5844,
	"./savao_smile": 8731,
	"./savao_smile.svg": 8731,
	"./yabao": 640,
	"./yabao.svg": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;